import {
    getResource,
    multiGetResources,
    updateResource,
    type ResourceId,
} from '@wwf/sdk';
import type { DataProvider } from 'react-admin';
import { toRecord } from '../utils';

export const resourceProvider: Partial<DataProvider> = {
    getOne: async (resource, params) => {
        const data = await getResource(params.id as ResourceId);
        return { data: toRecord(data) as any };
    },
    getMany: async (resource, params) => {
        const data = await multiGetResources(params.ids as ResourceId[]);
        return { data: data.map(toRecord) as any[] };
    },
    update: async (resource, params) => {
        const payload = params.data as Record<string, unknown>;
        const data = await updateResource(params.id as ResourceId, {
            name: payload.name as string | null | undefined,
            description: payload.description as string | null | undefined,
            alt: payload.alt as string | null | undefined,
            width: payload.width as number | null | undefined,
            height: payload.height as number | null | undefined,
            duration: payload.duration as number | null | undefined,
            thumbnail: payload.thumbnail as string | null | undefined,
        });
        return { data: toRecord(data) as any };
    },
};
